import { Heading2, IconButton40, IconNames16, Menu, MenuItem, Popover } from '@pinpointhq/thumbtack';
import * as React from 'react';
import ReactTable from 'react-table';
import { Company } from '../../../../javascript/models';
import humanize from '../../../shared/utilities/humanize';
import PaginationComponent from '../../candidates/awaiting/PaginationComponent';
import { AllocateDialog } from '../../shared/AllocateDialog';

export function CompanyJobs({ company }: { company: Company }) {
  const [selectedJobId, setSelectedJobId] = React.useState();

  const columns = [
    {
      Header: 'Job Title',
      accessor: 'title',
      sortable: false,
    },
    {
      Header: 'Cycle',
      accessor: 'cycle.name',
      sortable: false,
    },
    {
      Header: 'Programme',
      accessor: 'programme.name',
      sortable: false,
    },
    {
      Header: 'Workstream',
      accessor: 'workstream',
      sortable: false,
    },
    {
      Header: 'Region',
      accessor: 'region',
      sortable: false,
    },
    {
      Cell: (row) => {
        return <div>{humanize(row.original.progress)}</div>;
      },
      Header: 'Progress',
      accessor: 'progress',
      sortable: false,
    },
    {
      Header: 'Headcount',
      accessor: 'headcount',
      sortable: false,
      width: 120,
    },
    {
      Cell: (row: any) => {
        const handleClick = () => setSelectedJobId(row.original.id);

        return (
          <div>
            <Popover>
              <IconButton40 icon={IconNames16.OVERFLOW} />
              <Menu>
                <MenuItem text="Allocate" onClick={handleClick} />
              </Menu>
            </Popover>
          </div>
        );
      },
      Header: '',
      sortable: false,
      width: 80,
    },
  ];

  const handleClose = () => setSelectedJobId(null);

  const handleSuccess = () => window.location.reload();

  return (
    <div>
      <Heading2>Jobs</Heading2>
      <ReactTable
        columns={columns}
        data={company.jobs}
        PaginationComponent={PaginationComponent}
        loading={false}
        className="-unthemed"
        minRows={1}
        pageSize={5}
      />
      {selectedJobId && (
        <AllocateDialog
          isOpen={!!selectedJobId}
          jobId={selectedJobId}
          handleClose={handleClose}
          handleSuccess={handleSuccess}
        />
      )}
    </div>
  );
}
